import {
  DEFAULT_ADULTS,
  countPeople,
  getDefaultCheckinDateString,
  getDefaultCheckoutDateString,
} from '../helper/accommodation_helper';

export function showSearchConditionsMiniContainer() {
  const $ = (window as any).jQuery;

  $('.search-conditions-mini-container').show();
}

export function hideSearchConditionsMiniContainer() {
  const $ = (window as any).jQuery;

  $('.search-conditions-mini-container').hide();
}

export function displaySearchConditions(searchParams) {
  const $ = (window as any).jQuery;

  if (searchParams && searchParams.checkin_date && searchParams.checkout_date && searchParams.rooms) {
    $('#checkin-display').text(searchParams.checkin_date);
    $('#checkout-display').text(searchParams.checkout_date);
    $('#people-count-display').text(countPeople(searchParams.rooms));
  } else {
    $('#checkin-display').text(getDefaultCheckinDateString());
    $('#checkout-display').text(getDefaultCheckoutDateString());
    $('#people-count-display').text(DEFAULT_ADULTS);
  }
}
